import script from "./HistorialMantenimiento.vue?vue&type=script&setup=true&lang=js"
export * from "./HistorialMantenimiento.vue?vue&type=script&setup=true&lang=js"

import "./HistorialMantenimiento.vue?vue&type=style&index=0&id=ecaddb1a&scoped=true&lang=css"
import "./HistorialMantenimiento.vue?vue&type=style&index=1&id=ecaddb1a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecaddb1a"]])

export default __exports__